import { default as commonExtend } from '../common/extend';

export default [...commonExtend];
